<template>
  <!-- 映射表创建及编辑页面 -->
  <div class="main-content" v-loading="loading">
    <!-- 标题 -->
    <div class="text_title left">
      <!-- <span>字典项数据</span> -->
      <span class="back" @click="back">
        <i class="el-icon-back"></i>返回
      </span>
    </div>
    <!-- 表单 -->
    <inject-form id="form" ref="form" :formData="formData" :formList="valueMappingFormList" :formRule="formRule" @change="change"/>
    <!-- 映射表 表格-->
    <value-mapping-table id="valueTable" ref="valueTable" v-if="formData.mappingType === '0'" :tableData="valueData" :type="type" :bitOrValue="bitOrValue" />

    <bit-mapping-table id="bitTable" ref="bitTable" v-if="formData.mappingType === '1'" :tableData="bitData" :type="type" :bitOrValue="bitOrValue" />
    <!-- 确认及取消按键 -->

    <right-corner-buttons @confirm="confirm" />
  </div>
</template>
<script>
import InjectForm from '@/components/form/InjectForm.vue'
import ValueMappingTable from '@/tables/ValueMappingTable.vue'
import BitMappingTable from '@/tables/BitMappingTable.vue'
import RightCornerButtons from '@/components/buttons/RightCornerButtons.vue'

import { valueMappingFormList } from '@/data/formList'
import { mappingFormRules } from '@/data/rules'

import { viewValueMappingform, viewBitMappingform, createValueMappingform, createBitMappingform, updateValueMappingform, updateBitMappingform } from '@/api/mappingform/mappingform'
import { proValidation } from '@/utils/tableValidation'

export default {
  name: 'FormCreateView',
  components: {
    InjectForm,
    ValueMappingTable,
    BitMappingTable,
    RightCornerButtons
  },
  data () {
    return {
      // 页面类别，add: 创建，edit: 编辑
      type: this.$route.query.type || 'add',
      // 映射表id
      formId: this.$route.query.id || '',
      // 映射类别，0: 值映射，1: 位映射
      mappingType: this.$route.query.mappingType || '',
      // 映射表表单列表
      valueMappingFormList: valueMappingFormList,
      // 表单数据标准格式，用于初始化表单数据
      formData: {
        mappingName: '',
        mappingContent: '',
        mappingType: '1',
        mappingValue: []
      },
      // 表单校验规则
      formRule: mappingFormRules,
      // 映射表表格数据
      bitData: [],
      valueData: [],
      bitOrValue: '1', // 0: 值映射，1: 位映射 ,默认位映射
      loading: false
    }
  },
  mounted () {
    this.loadFormInfo()
    // 字典下拉框赋值
    this.$assignDictOptions(this.valueMappingFormList, { mappingType: 'mapping_type' }, this.selectDictionary)
  },
  computed: {
    selectDictionary () {
      return this.$store.getters.getDictionaryList
    }
  },
  watch: {
    $route: {
      handler (to, from) {
        // 当路由切换到此页面时重置数据
        if (to.name === 'FormManageView') {
          this.resetFormAndTable()
        }
        // 当路由变化时重新加载详情
        this.loadFormInfo()
        if (to.name === 'FormCreateView' && this.formData.mappingType === 'bit位映射') {
          // 初始化位映射表数据
          this.bitData = [
            {
              id: undefined,
              index: '',
              startingBit: '',
              bitLength: '',
              name: '',
              bitValueKey: [{ id: undefined, index: '', key: '', value: '' }]
            }
          ]
        }
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    // 重置表单和表格数据
    resetFormAndTable () {
      // 重置表单数据
      this.formData = {
        mappingName: '',
        mappingContent: '',
        mappingType: '1',
        mappingValue: []
      }

      // 重置表格数据
      this.bitData = []
      this.valueData = []

      // 重置表单验证状态
      if (this.$refs.form && this.$refs.form.resetFields) {
        this.$refs.form.resetFields()
      }

      // 重置表格状态
      if (this.$refs.valueTable && this.$refs.valueTable.resetTable) {
        this.$refs.valueTable.resetTable()
      }
      if (this.$refs.bitTable && this.$refs.bitTable.resetTable) {
        this.$refs.bitTable.resetTable()
      }
    },
    // 获取详情的方法
    loadFormInfo () {
      this.loading = true
      // 编辑映射表时，获取映射表信息
      if (this.type === 'edit' && this.$route.query.id && this.$route.query.mappingType === '值映射') {
        // 获取值映射表信息
        this.getValueFormInfo(this.$route.query.id)
      } else if (this.type === 'edit' && this.$route.query.id && this.$route.query.mappingType === 'bit位映射') {
        // 获取位映射表信息
        this.getBitFormInfo(this.$route.query.id)
      } else {
        // 默认bit表格数据
        this.bitData = [
          {
            index: undefined,
            startingBit: 0,
            bitLength: 1,
            mappingValue: '',
            bitValueKey: [{ index: undefined, key: '', value: '' }]
          }
        ]
      }
      this.loading = false
    },
    // 获取值映射表信息
    async getValueFormInfo (id) {
      const res = await viewValueMappingform(id)
      this.formData = res.data
      this.formData.mappingType = res.data.mappingType + ''
      this.bitOrValue = res.data.mappingType + ''

      const data = {
        typeNum: res.data.mappingValue.length,
        mappingValue: res.data.mappingValue
      }
      this.valueData = []
      this.valueData.push(JSON.parse(JSON.stringify(data)))
    },
    // 获取位映射表信息
    async getBitFormInfo (id) {
      const res = await viewBitMappingform(id)
      this.formData = res.data
      this.formData.mappingType = res.data.mappingType + ''
      this.bitData = res.data.mappingValue
      this.bitOrValue = res.data.mappingType + ''
    },
    // 确认按钮点击事件
    async confirm () {
      this.loading = true
      const vilidation = await this.handleValidation()
      if (!vilidation) {
        this.$message.error('校验失败, 请检查输入内容是否有缺失或错误')
        this.loading = false
        return
      }
      if (this.type === 'add') {
        if (this.bitOrValue === '1') {
          this.createBitForm()
        } else if (this.bitOrValue === '0') {
          this.createValueForm()
        }
      } else if (this.type === 'edit') {
        if (this.bitOrValue === '1') {
          this.updateBitForm()
        } else if (this.bitOrValue === '0') {
          this.updateValueForm()
        }
      }
    },
    // 显示信息
    showInfo (res) {
      if (res.code === 200) {
        this.$message.success(res.msg)
        this.$addHandler('/form/manage', '映射表管理')
        this.loading = false
      } else {
        this.loading = false
        this.$message.error(res.msg)
      }
    },
    // 表单校验处理
    async handleValidation () {
      let isRight = false
      try {
        isRight = await proValidation(this.$refs.form)
        if (isRight && this.formData.mappingType === '0') {
          isRight = await proValidation(this.$refs.valueTable)
        } else if (isRight && this.formData.mappingType === '1') {
          isRight = await proValidation(this.$refs.bitTable)
        }
      } catch (error) {
        console.log('handleValidation error', error)
      }
      return isRight
    },
    // 创建值映射表
    async createValueForm () {
      this.formData.mappingValue = this.valueData[0].mappingValue
      const res = await createValueMappingform(this.formData)
      this.showInfo(res)
    },
    // 创建位映射表
    async createBitForm () {
      this.formData.mappingValue = this.bitData
      const res = await createBitMappingform(this.formData)
      this.showInfo(res)
    },
    // 更新值映射表
    async updateValueForm () {
      this.valueData[0].mappingValue.forEach((item, index) => {
        item.index = index
      })
      this.formData.mappingValue = this.valueData[0].mappingValue
      const res = await updateValueMappingform(this.formData)
      this.showInfo(res)
    },
    // 更新位映射表
    async updateBitForm () {
      this.bitData.forEach((item, index) => {
        item.index = index
        item.bitValueKey.forEach((itm, indx) => {
          itm.index = indx
        })
      })
      this.formData.mappingValue = this.bitData
      const res = await updateBitMappingform(this.formData)
      this.showInfo(res)
    },
    async change (val) {
      this.bitOrValue = val
      if (val === '1') {
        if (this.bitData.length === 0) {
          this.bitData = [
            {
              id: undefined,
              index: '',
              startingBit: '',
              bitLength: '',
              name: '',
              bitValueKey: [
                {
                  id: undefined,
                  index: '',
                  key: '',
                  value: ''
                }
              ]
            }
          ]
        }
      } else if (val === '0') {
        if (this.valueData.length === 0) {
          this.valueData = [
            {
              typeNum: 1,
              mappingValue: [
                {
                  id: undefined,
                  index: '',
                  key: '',
                  value: ''
                }
              ]
            }

          ]
        }
      }
    },
    back () {
      this.$router.go(-1)
    }
  }
}
</script>

<style scoped>

.form .el-input {
  text-align: flex-start;
  --el-input-width: 220px;
}

.form .el-select {
  --el-select-width: 220px;
}
</style>
